/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
import { pricingConfidenceSchema, pricingExtractedInputSchema, pricingInputs, } from './inputs.generated';
export { pricingExtractedInputSchema, pricingInputFieldSchema, pricingInputs, } from './inputs.generated';
export const pricingPreviewSchema = z.strictObject({
    scenarios: z
        .array(z.strictObject({
        source_scenario: z.string().min(1).max(255),
        row_id: z.uuid().optional(),
        scenario_id: z.int().positive().nullable(),
        confidence: pricingConfidenceSchema,
        inputs: z.array(pricingExtractedInputSchema).max(60),
    }))
        .max(200),
});
// Stage and counts only; never labels or values.
export const pricingAnalysisProgressSchema = z
    .strictObject({
    stage: z.enum(['parsing', 'matching', 'mapping', 'validating']),
    done: z.int().nonnegative(),
    total: z.int().nonnegative(),
})
    .refine(({ done, total }) => done <= total, 'Invalid progress counts.');
// One Upload Pricing Scenarios Prefect run, as the app server reports it to the UI.
export const pricingAnalysisRunSchema = z
    .strictObject({
    run_id: z.uuid(),
    state: z.enum(['pending', 'running', 'ready', 'failed']),
    preview: pricingPreviewSchema.nullable(),
    progress: pricingAnalysisProgressSchema.nullable(),
})
    .refine((run) => (run.state === 'ready') === (run.preview !== null), 'Invalid analysis state.')
    .refine((run) => run.state === 'running' || !run.progress, 'Invalid analysis progress.');
export function blankPricingScenario(scenarioId = null) {
    return {
        row_id: crypto.randomUUID(),
        source_scenario: 'Manual scenario',
        scenario_id: scenarioId,
        confidence: 'low',
        inputs: pricingInputs.map(({ field, unit }) => ({
            field,
            unit,
            value: null,
            confidence: 'low',
        })),
    };
}
export function requiredPricingFields(scenario) {
    const required = ['Plant_Configuration__c', 'COD__c'];
    if (scenario.products.some((product) => product.includes('build-transfer'))) {
        required.push('BTA_Price__c');
    }
    else {
        if (scenario.plant_type.includes('PV') || scenario.plant_type.includes('WIND')) {
            required.push('PPA_Price_MWh__c');
        }
        if (scenario.plant_type.includes('BESS'))
            required.push('Capacity_Payment_MW_month__c');
    }
    return required;
}
export function isMissingPricingValue(value) {
    return value == null || value === '' || (Array.isArray(value) && !value.length);
}
//# sourceMappingURL=preview.js.map